import { inject, Injectable } from '@angular/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';
import { SystemService } from '../core/system.service';

@Injectable({
  providedIn: 'root'
})
export class AndroidHelperService {
  private readonly system = inject(SystemService);

  async downloadMaterialInAndroid(event: Event, url: string) {
    if (!this.system.isMobile()) return;

    event.preventDefault();
    event.stopPropagation();

    await Filesystem.downloadFile({
      url: url,
      path: 'downloaded-file.pdf',
      directory: Directory.Documents,
      progress: true
    });
  }

  async downloadPDFInAndroid(blob: Blob, fileName: string) {
    if (!this.system.isMobile()) return;

    const base64 = await blobToBase64(blob);

    const { uri } = await Filesystem.writeFile({
      path: fileName,
      data: base64,
      directory: Directory.Documents,
      recursive: true,
    });

    await FileOpener.open({
      filePath: uri,
      contentType: blob.type || 'application/pdf',
    });
  }
}

function blobToBase64(b: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onerror = () => reject(r.error);
    r.onload = () => resolve((r.result as string).split(',')[1]); // strip data URL prefix
    r.readAsDataURL(b);
  });
}
